export default function mapTravelModeNameToCode(name: string) {
  switch (name) {
    case 'N/A':
      return '0';
    case 'Road Only':
      return '1';
    case 'Flyable(Not Ideal)':
      return '2';
    case 'Flyable':
      return '3';
    case 'Sea/Barge':
      return '4';
    default:
      return '0';
  }
}
